import { useParams } from 'react-router';

type Params = {
  akaProduktId?: string;
  akaVeranstaltungId?: string;
  akaDurchgangId?: string;
};

export const useNormalizedParams = () => useParams<Params>();
